import initialState from '../store/initialState'
import competenciesTypes from '../constants/competenciesTypes'
import preferencesTypes from '../constants/preferencesTypes'

export default function competenciesReducer(state = initialState.competencies, action) {
  switch (action.type) {

    case competenciesTypes.set_errors: {
      return {
        ...state,
        errors: action.payload
      }
    }

    case competenciesTypes.reset_competency: {
      return {
        ...initialState.competencies,
        items: state.items,
        competency: state.competency,
        errors: []
      }
    }

    // INDEX
    case competenciesTypes.index.request: {
      return {
        ...state,
        fetching: true,
        fetched: false,
        errors: []
      }
    }

    case competenciesTypes.index.success:
    case preferencesTypes.update.success:
    case preferencesTypes.index.success: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        items: action.payload.competencies,
        errors: []
      }
    }

    case competenciesTypes.index.failure: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload
      }
    }

    case competenciesTypes.create.request: {
      return {
        ...state,
        fetching: true,
        fetched: false,
        must_redirect: false,
        errors: []
      }
    }

    case competenciesTypes.create.success: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        must_redirect: true,
        items: action.payload.competencies,
        errors: []
      }
    }

    case competenciesTypes.create.failure: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        must_redirect: false,
        errors: action.payload
      }
    }

    default: {
      return {...state};
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/reducers/competenciesReducer.js